import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosClientSignIn } from "../axios/api";
import storage from 'redux-persist/lib/storage'; // Uses localStorage
// One definition of where the Sales Command Center's backend lives, so the logout below
// cannot drift away from the URL the rest of the module talks to.
import { MOBILE_API_BASE } from '../SalesCommandCenter/hooks/useMobileOrgApi';
// Async thunk to verify if session exists
export const checkSession = createAsyncThunk(
  'auth/checkSession',
  async (_, { rejectWithValue }) => {
    try {
      // const token = localStorage.getItem('token');
      // if (!token) throw new Error("No token found");
       console.log("session ------------------------------------------------------>")
      const response = await axiosClientSignIn.get('/api/check-session');
       console.log(response.data)
      return response.data; // Expecting { user: { ...userData } }
    } catch (error) {
      // localStorage.removeItem('token');
      // localStorage.removeItem('user');
      return rejectWithValue("Session expired, please log in again.");
    }
  }
);

export const signIn = createAsyncThunk(
  'auth/signIn',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post('api/login', credentials);
      console.log(response.data )
      const { token, user } = response.data;
      
      // localStorage.setItem('token', token);
      // localStorage.setItem('user', JSON.stringify(user));

      return { token, user };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Sign-in failed.');
    }
  }
);

export const signUp = createAsyncThunk(
  'auth/signUp',
  async (userData, { rejectWithValue }) => {
    try {
      console.log(userData)
      const response = await axiosClientSignIn.post('api/signup', userData);
      return response.data.message;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Sign-up failed.');
    }
  }
);

export const approveUser = createAsyncThunk(
  "auth/approveUser",
  async ({ token, action }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post("api/approve", { token, action });
      console.log( response.data)
      return response.data.message; // Return success message
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Approval failed.");
    }
  }
);


export const approvePasswordReset = createAsyncThunk(
  "auth/approvePasswordReset",
  async ({ token, action }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post(`/api/reset-password/approve/${token}`, { action });
      console.log(response.data);
      return response.data.message; // Expecting success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Password reset approval failed.");
    }
  }
);

export const getUserInformation = createAsyncThunk(
  "auth/getUserInformation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get("userlist/profile");

      // ✅ Assuming backend returns { success: true, data: { ...profileData } }
      if (response.data.success) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data.message || "Failed to load user information");
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
      return rejectWithValue(error.response?.data || "Error fetching user information");
    }
  }
);


// ✅ FIXED - Accept hours parameter!
export const extendSessionHour = createAsyncThunk(
  "auth/extendSessionHour", 
  async (hours, { rejectWithValue }) => {  // 👈 hours comes from component!
    try {
      const response = await axiosClientSignIn.post("/api/session/extend", { 
        extendHours: hours  // 👈 Use the passed hours!
      });
      return response.data; // Returns { message, expiresAt, warningAt }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to extend session.");
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async (_, { rejectWithValue }) => {
  try {
    await axiosClientSignIn.post("/api/logout");
    /*
     * End the Sales Command Center session too.
     *
     * It is a second session on a second service, and signing out of the ERP did not
     * touch it — so it outlived the logout by its full nine-hour lifetime. That left a
     * signed-out person's session live for the next user of that browser, who saw their
     * own name in the ERP header above the previous user's queues and figures.
     *
     * Best-effort and awaited only briefly: the ERP logout must complete whether or not
     * this service is reachable, so a failure here is swallowed rather than surfaced.
     */
    await fetch(`${MOBILE_API_BASE}/auth/logout`, {
      method: "POST",
      credentials: "include",
    }).catch(() => {});
    localStorage.removeItem("token"); // Clear token on logout
    return "Logged out successfully";
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Logout failed.");
  }
});


const initialState = {
  user: (() => {
    // const user = localStorage.getItem('user');
    // return user ? JSON.parse(user) : null;
  })(),
  userInfo:{},
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,
  sessionChecked: null, // Prevents multiple calls to checkSession
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
   
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        console.log(action.payload,"singisn full filled")
        state.user = action.payload.user;
        // state.sessionChecked = true;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Sign-in failed.';
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signUp.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Sign-up failed.';
      })
      .addCase(checkSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkSession.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload,"check session fuiiled")
        state.user = action.payload.user;
        state.sessionChecked = true;
      })
      .addCase(checkSession.rejected, (state) => {
        state.loading = false;
        state.user = null;
        state.token = null;
        state.sessionChecked = false;
      }).addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.sessionChecked = false;
        state.sessionExpiry = null;


      }) 
       .addCase(extendSessionHour.pending, (state) => {
        state.loading = true;
      })
      .addCase(extendSessionHour.fulfilled, (state, action) => {
        state.loading = false;
        state.sessionExpiry = action.payload.expiresAt; // Store new expiry
        console.log("✅ Session extended, new expiry:", action.payload.expiresAt);
      })
      .addCase(extendSessionHour.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to extend session.";
      })
      .addCase(getUserInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserInformation.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload; // ✅ Save profile data
        if (state.user && action.payload?.personalInfo) {
          state.user = {
            ...state.user,
            firstName: action.payload.personalInfo.firstName || state.user.firstName,
            lastName: action.payload.personalInfo.lastName || state.user.lastName,
            phone: action.payload.personalInfo.contact || state.user.phone,
            profileImage: action.payload.personalInfo.profileImage || state.user.profileImage
          };
        }
      })
      .addCase(getUserInformation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch user info.";
      })
    }
});

export const { clearError } = authSlice.actions;
export default authSlice.reducer;
